import React from "react";

function LMMETableau({
  formData,
  setFormData,
  handleCheckboxChange,
  handleInputChange,
}) {
  return (
    <div className="Annexe2">
      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            <th style={{ textAlign: "center" }}></th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Intitulé des prestations
            </th>
            <th
              style={{
                border: "1px solid black",
                padding: "8px",
                textAlign: "center",
              }}
            >
              Honoraires
            </th>
          </tr>
        </thead>
        <tbody>
          {/* Partie 1 */}
          <tr>
            <td></td>
            <td>Accompagnement à la création de la micro-entreprise</td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="mecdo"
                checked={formData.mecdo === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Choix des options
            </td>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
              rowSpan={2}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <select
                  name="aalcdlme"
                  value={
                    formData.aalcdlme.endsWith("HT € / mois")
                      ? "Honoraire"
                      : formData.aalcdlme
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "Honoraire") {
                      setFormData({ ...formData, aalcdlme: "" }); // prépa pour la saisie
                    } else {
                      setFormData({ ...formData, aalcdlme: value });
                    }
                  }}
                  style={{
                    fontSize: "10px",
                    borderRadius: "4px",
                    border: "1px solid #840040",
                  }}
                >
                  <option value="N/A">N/A</option>
                  <option value="INCLUS DANS LE FORFAIT">
                    INCLUS DANS LE FORFAIT
                  </option>
                  <option value="Honoraire">Honoraire</option>
                </select>

                {/* Champ visible uniquement si on est en saisie d'honoraire */}
                {formData.aalcdlme !== "N/A" &&
                  formData.aalcdlme !== "INCLUS DANS LE FORFAIT" && (
                    <input
                      type="text"
                      placeholder="Ex: 33,00"
                      value={formData.aalcdlme.replace(" HT € / mois", "")}
                      onChange={(e) => {
                        let raw = e.target.value
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        if (raw === "") {
                          setFormData({ ...formData, aalcdlme: "" });
                          return;
                        }

                        let num = parseFloat(raw);
                        if (!isNaN(num)) {
                          // ne formate pas tout de suite, garde la saisie libre
                          const parts = raw.split(".");
                          let formatted =
                            parts.length === 2
                              ? parts[0] + "," + parts[1].substring(0, 2)
                              : parts[0];
                          setFormData({ ...formData, aalcdlme: formatted });
                        }
                      }}
                      onBlur={() => {
                        let input = formData.aalcdlme
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        let num = parseFloat(input);
                        if (!isNaN(num)) {
                          let formatted = num.toFixed(2).replace(".", ",");
                          setFormData({
                            ...formData,
                            aalcdlme: `${formatted} HT € / mois`,
                          });
                        } else {
                          setFormData({ ...formData, aalcdlme: "" });
                        }
                      }}
                      style={{
                        marginTop: "5px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        border: "1px solid #840040",
                      }}
                    />
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="mefdi"
                checked={formData.mefdi === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Formalités d’immatriculation
            </td>
          </tr>

          {/* Partie 2 */}
          <tr>
            <td></td>
            <td>
              Accompagnement dans la mise en place de l’organisation
              administrative et comptable
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="meaalm"
                checked={formData.meaalm === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Accompagnement à la mise en place de l’organisation
            </td>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
              rowSpan={2}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <select
                  name="adlme"
                  value={
                    formData.adlme.endsWith("HT € / mois")
                      ? "Honoraire"
                      : formData.adlme
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "Honoraire") {
                      setFormData({ ...formData, adlme: "" }); // prépa pour la saisie
                    } else {
                      setFormData({ ...formData, adlme: value });
                    }
                  }}
                  style={{
                    fontSize: "10px",
                    borderRadius: "4px",
                    border: "1px solid #840040",
                  }}
                >
                  <option value="N/A">N/A</option>
                  <option value="INCLUS DANS LE FORFAIT">
                    INCLUS DANS LE FORFAIT
                  </option>
                  <option value="Honoraire">Honoraire</option>
                </select>

                {/* Champ visible uniquement si on est en saisie d'honoraire */}
                {formData.adlme !== "N/A" &&
                  formData.adlme !== "INCLUS DANS LE FORFAIT" && (
                    <input
                      type="text"
                      placeholder="Ex: 33,00"
                      value={formData.adlme.replace(" HT € / mois", "")}
                      onChange={(e) => {
                        let raw = e.target.value
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        if (raw === "") {
                          setFormData({ ...formData, adlme: "" });
                          return;
                        }

                        let num = parseFloat(raw);
                        if (!isNaN(num)) {
                          // ne formate pas tout de suite, garde la saisie libre
                          const parts = raw.split(".");
                          let formatted =
                            parts.length === 2
                              ? parts[0] + "," + parts[1].substring(0, 2)
                              : parts[0];
                          setFormData({ ...formData, adlme: formatted });
                        }
                      }}
                      onBlur={() => {
                        let input = formData.adlme
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        let num = parseFloat(input);
                        if (!isNaN(num)) {
                          let formatted = num.toFixed(2).replace(".", ",");
                          setFormData({
                            ...formData,
                            adlme: `${formatted} HT € / mois`,
                          });
                        } else {
                          setFormData({ ...formData, adlme: "" });
                        }
                      }}
                      style={{
                        marginTop: "5px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        border: "1px solid #840040",
                      }}
                    />
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="mecalr"
                checked={formData.mecalr === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Conformité à la réglementation administrative et comptable
            </td>
          </tr>

          {/* Partie 3 */}
          <tr>
            <td></td>
            <td>Suivi comptable</td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="mepvm"
                checked={formData.mepvm === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Par vous-même
            </td>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
              rowSpan={3}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <select
                  name="sc"
                  value={
                    formData.sc.endsWith("HT € / mois")
                      ? "Honoraire"
                      : formData.sc
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "Honoraire") {
                      setFormData({ ...formData, sc: "" }); // prépa pour la saisie
                    } else {
                      setFormData({ ...formData, sc: value });
                    }
                  }}
                  style={{
                    fontSize: "10px",
                    borderRadius: "4px",
                    border: "1px solid #840040",
                  }}
                >
                  <option value="N/A">N/A</option>
                  <option value="INCLUS DANS LE FORFAIT">
                    INCLUS DANS LE FORFAIT
                  </option>
                  <option value="Honoraire">Honoraire</option>
                </select>

                {/* Champ visible uniquement si on est en saisie d'honoraire */}
                {formData.sc !== "N/A" &&
                  formData.sc !== "INCLUS DANS LE FORFAIT" && (
                    <input
                      type="text"
                      placeholder="Ex: 33,00"
                      value={formData.sc.replace(" HT € / mois", "")}
                      onChange={(e) => {
                        let raw = e.target.value
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        if (raw === "") {
                          setFormData({ ...formData, sc: "" });
                          return;
                        }

                        let num = parseFloat(raw);
                        if (!isNaN(num)) {
                          // ne formate pas tout de suite, garde la saisie libre
                          const parts = raw.split(".");
                          let formatted =
                            parts.length === 2
                              ? parts[0] + "," + parts[1].substring(0, 2)
                              : parts[0];
                          setFormData({ ...formData, sc: formatted });
                        }
                      }}
                      onBlur={() => {
                        let input = formData.sc
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        let num = parseFloat(input);
                        if (!isNaN(num)) {
                          let formatted = num.toFixed(2).replace(".", ",");
                          setFormData({
                            ...formData,
                            sc: `${formatted} HT € / mois`,
                          });
                        } else {
                          setFormData({ ...formData, sc: "" });
                        }
                      }}
                      style={{
                        marginTop: "5px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        border: "1px solid #840040",
                      }}
                    />
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="mepvmsu"
                checked={formData.mepvmsu === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Par vous-même, sur un support mis en ligne par notre cabinet
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="mepnc"
                checked={formData.mepnc === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Par notre cabinet
            </td>
          </tr>

          {/* Partie 4 */}
          <tr>
            <td></td>
            <td>Accompagnement aux déclarations de TVA</td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="medpvm1"
                checked={formData.medpvm1 === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclaration par vous-même
            </td>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
              rowSpan={2}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <select
                  name="aaddt"
                  value={
                    formData.aaddt.endsWith("HT € / mois")
                      ? "Honoraire"
                      : formData.aaddt
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "Honoraire") {
                      setFormData({ ...formData, aaddt: "" }); // prépa pour la saisie
                    } else {
                      setFormData({ ...formData, aaddt: value });
                    }
                  }}
                  style={{
                    fontSize: "10px",
                    borderRadius: "4px",
                    border: "1px solid #840040",
                  }}
                >
                  <option value="N/A">N/A</option>
                  <option value="INCLUS DANS LE FORFAIT">
                    INCLUS DANS LE FORFAIT
                  </option>
                  <option value="Honoraire">Honoraire</option>
                </select>

                {/* Champ visible uniquement si on est en saisie d'honoraire */}
                {formData.aaddt !== "N/A" &&
                  formData.aaddt !== "INCLUS DANS LE FORFAIT" && (
                    <input
                      type="text"
                      placeholder="Ex: 33,00"
                      value={formData.aaddt.replace(" HT € / mois", "")}
                      onChange={(e) => {
                        let raw = e.target.value
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        if (raw === "") {
                          setFormData({ ...formData, aaddt: "" });
                          return;
                        }

                        let num = parseFloat(raw);
                        if (!isNaN(num)) {
                          // ne formate pas tout de suite, garde la saisie libre
                          const parts = raw.split(".");
                          let formatted =
                            parts.length === 2
                              ? parts[0] + "," + parts[1].substring(0, 2)
                              : parts[0];
                          setFormData({ ...formData, aaddt: formatted });
                        }
                      }}
                      onBlur={() => {
                        let input = formData.aaddt
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        let num = parseFloat(input);
                        if (!isNaN(num)) {
                          let formatted = num.toFixed(2).replace(".", ",");
                          setFormData({
                            ...formData,
                            aaddt: `${formatted} HT € / mois`,
                          });
                        } else {
                          setFormData({ ...formData, aaddt: "" });
                        }
                      }}
                      style={{
                        marginTop: "5px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        border: "1px solid #840040",
                      }}
                    />
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="medpvc1"
                checked={formData.medpvc1 === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclaration pour votre compte de la TVA de la période
            </td>
          </tr>

          {/* Partie 5 */}
          <tr>
            <td></td>
            <td>
              {" "}
              Accompagnement aux déclarations de cotisations sociales (URSSAF)
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="medpvm2"
                checked={formData.medpvm2 === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclaration par vous-même
            </td>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
              rowSpan={2}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <select
                  name="aaddcs"
                  value={
                    formData.aaddcs.endsWith("HT € / mois")
                      ? "Honoraire"
                      : formData.aaddcs
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "Honoraire") {
                      setFormData({ ...formData, aaddcs: "" }); // prépa pour la saisie
                    } else {
                      setFormData({ ...formData, aaddcs: value });
                    }
                  }}
                  style={{
                    fontSize: "10px",
                    borderRadius: "4px",
                    border: "1px solid #840040",
                  }}
                >
                  <option value="N/A">N/A</option>
                  <option value="INCLUS DANS LE FORFAIT">
                    INCLUS DANS LE FORFAIT
                  </option>
                  <option value="Honoraire">Honoraire</option>
                </select>

                {/* Champ visible uniquement si on est en saisie d'honoraire */}
                {formData.aaddcs !== "N/A" &&
                  formData.aaddcs !== "INCLUS DANS LE FORFAIT" && (
                    <input
                      type="text"
                      placeholder="Ex: 33,00"
                      value={formData.aaddcs.replace(" HT € / mois", "")}
                      onChange={(e) => {
                        let raw = e.target.value
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        if (raw === "") {
                          setFormData({ ...formData, aaddcs: "" });
                          return;
                        }

                        let num = parseFloat(raw);
                        if (!isNaN(num)) {
                          // ne formate pas tout de suite, garde la saisie libre
                          const parts = raw.split(".");
                          let formatted =
                            parts.length === 2
                              ? parts[0] + "," + parts[1].substring(0, 2)
                              : parts[0];
                          setFormData({ ...formData, aaddcs: formatted });
                        }
                      }}
                      onBlur={() => {
                        let input = formData.aaddcs
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        let num = parseFloat(input);
                        if (!isNaN(num)) {
                          let formatted = num.toFixed(2).replace(".", ",");
                          setFormData({
                            ...formData,
                            aaddcs: `${formatted} HT € / mois`,
                          });
                        } else {
                          setFormData({ ...formData, aaddcs: "" });
                        }
                      }}
                      style={{
                        marginTop: "5px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        border: "1px solid #840040",
                      }}
                    />
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="medpvc2"
                checked={formData.medpvc2 === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Déclaration pour votre compte du chiffre d’affaires de la période
            </td>
          </tr>

          {/* Partie 6 */}
          <tr>
            <td></td>
            <td>Accompagnement à la déclaration d’impôt sur le revenu</td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="mepvmaa"
                checked={formData.mepvmaa === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Par vous-même
            </td>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
              rowSpan={3}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <select
                  name="aaldds"
                  value={
                    formData.aaldds.endsWith("HT € / mois")
                      ? "Honoraire"
                      : formData.aaldds
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "Honoraire") {
                      setFormData({ ...formData, aaldds: "" }); // prépa pour la saisie
                    } else {
                      setFormData({ ...formData, aaldds: value });
                    }
                  }}
                  style={{
                    fontSize: "10px",
                    borderRadius: "4px",
                    border: "1px solid #840040",
                  }}
                >
                  <option value="N/A">N/A</option>
                  <option value="INCLUS DANS LE FORFAIT">
                    INCLUS DANS LE FORFAIT
                  </option>
                  <option value="Honoraire">Honoraire</option>
                </select>

                {/* Champ visible uniquement si on est en saisie d'honoraire */}
                {formData.aaldds !== "N/A" &&
                  formData.aaldds !== "INCLUS DANS LE FORFAIT" && (
                    <input
                      type="text"
                      placeholder="Ex: 33,00"
                      value={formData.aaldds.replace(" HT € / mois", "")}
                      onChange={(e) => {
                        let raw = e.target.value
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        if (raw === "") {
                          setFormData({ ...formData, aaldds: "" });
                          return;
                        }

                        let num = parseFloat(raw);
                        if (!isNaN(num)) {
                          // ne formate pas tout de suite, garde la saisie libre
                          const parts = raw.split(".");
                          let formatted =
                            parts.length === 2
                              ? parts[0] + "," + parts[1].substring(0, 2)
                              : parts[0];
                          setFormData({ ...formData, aaldds: formatted });
                        }
                      }}
                      onBlur={() => {
                        let input = formData.aaldds
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        let num = parseFloat(input);
                        if (!isNaN(num)) {
                          let formatted = num.toFixed(2).replace(".", ",");
                          setFormData({
                            ...formData,
                            aaldds: `${formatted} HT € / mois`,
                          });
                        } else {
                          setFormData({ ...formData, aaldds: "" });
                        }
                      }}
                      style={{
                        marginTop: "5px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        border: "1px solid #840040",
                      }}
                    />
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="meaplc"
                checked={formData.meaplc === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Assistance par le cabinet
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="meedl"
                checked={formData.meedl === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Estimation de l’impôt
            </td>
          </tr>

          {/* Partie 7 */}
          <tr>
            <td></td>
            <td>Synthèse financière annuelle</td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="merddds"
                checked={formData.merddds === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Remise d’un document de synthèse
            </td>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
              rowSpan={2}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <select
                  name="sfa"
                  value={
                    formData.sfa.endsWith("HT € / mois")
                      ? "Honoraire"
                      : formData.sfa
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "Honoraire") {
                      setFormData({ ...formData, sfa: "" }); // prépa pour la saisie
                    } else {
                      setFormData({ ...formData, sfa: value });
                    }
                  }}
                  style={{
                    fontSize: "10px",
                    borderRadius: "4px",
                    border: "1px solid #840040",
                  }}
                >
                  <option value="N/A">N/A</option>
                  <option value="INCLUS DANS LE FORFAIT">
                    INCLUS DANS LE FORFAIT
                  </option>
                  <option value="Honoraire">Honoraire</option>
                </select>

                {/* Champ visible uniquement si on est en saisie d'honoraire */}
                {formData.sfa !== "N/A" &&
                  formData.sfa !== "INCLUS DANS LE FORFAIT" && (
                    <input
                      type="text"
                      placeholder="Ex: 33,00"
                      value={formData.sfa.replace(" HT € / mois", "")}
                      onChange={(e) => {
                        let raw = e.target.value
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        if (raw === "") {
                          setFormData({ ...formData, sfa: "" });
                          return;
                        }

                        let num = parseFloat(raw);
                        if (!isNaN(num)) {
                          // ne formate pas tout de suite, garde la saisie libre
                          const parts = raw.split(".");
                          let formatted =
                            parts.length === 2
                              ? parts[0] + "," + parts[1].substring(0, 2)
                              : parts[0];
                          setFormData({ ...formData, sfa: formatted });
                        }
                      }}
                      onBlur={() => {
                        let input = formData.sfa
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        let num = parseFloat(input);
                        if (!isNaN(num)) {
                          let formatted = num.toFixed(2).replace(".", ",");
                          setFormData({
                            ...formData,
                            sfa: `${formatted} HT € / mois`,
                          });
                        } else {
                          setFormData({ ...formData, sfa: "" });
                        }
                      }}
                      style={{
                        marginTop: "5px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        border: "1px solid #840040",
                      }}
                    />
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="meaeac"
                checked={formData.meaeac === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Avec entretien au cabinet
            </td>
          </tr>

          {/* Partie 8 */}
          <tr>
            <td></td>
            <td>Accompagnement sur le choix d’un statut</td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="merdsc"
                checked={formData.merdsc === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Remise d’une simulation chiffrée
            </td>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
              rowSpan={2}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <select
                  name="aslcds"
                  value={
                    formData.aslcds.endsWith("HT € / mois")
                      ? "Honoraire"
                      : formData.aslcds
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "Honoraire") {
                      setFormData({ ...formData, aslcds: "" }); // prépa pour la saisie
                    } else {
                      setFormData({ ...formData, aslcds: value });
                    }
                  }}
                  style={{
                    fontSize: "10px",
                    borderRadius: "4px",
                    border: "1px solid #840040",
                  }}
                >
                  <option value="N/A">N/A</option>
                  <option value="INCLUS DANS LE FORFAIT">
                    INCLUS DANS LE FORFAIT
                  </option>
                  <option value="Honoraire">Honoraire</option>
                </select>

                {/* Champ visible uniquement si on est en saisie d'honoraire */}
                {formData.aslcds !== "N/A" &&
                  formData.aslcds !== "INCLUS DANS LE FORFAIT" && (
                    <input
                      type="text"
                      placeholder="Ex: 33,00"
                      value={formData.aslcds.replace(" HT € / mois", "")}
                      onChange={(e) => {
                        let raw = e.target.value
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        if (raw === "") {
                          setFormData({ ...formData, aslcds: "" });
                          return;
                        }

                        let num = parseFloat(raw);
                        if (!isNaN(num)) {
                          // ne formate pas tout de suite, garde la saisie libre
                          const parts = raw.split(".");
                          let formatted =
                            parts.length === 2
                              ? parts[0] + "," + parts[1].substring(0, 2)
                              : parts[0];
                          setFormData({ ...formData, aslcds: formatted });
                        }
                      }}
                      onBlur={() => {
                        let input = formData.aslcds
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        let num = parseFloat(input);
                        if (!isNaN(num)) {
                          let formatted = num.toFixed(2).replace(".", ",");
                          setFormData({
                            ...formData,
                            aslcds: `${formatted} HT € / mois`,
                          });
                        } else {
                          setFormData({ ...formData, aslcds: "" });
                        }
                      }}
                      style={{
                        marginTop: "5px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        border: "1px solid #840040",
                      }}
                    />
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="meaeac2"
                checked={formData.meaeac2 === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Avec entretien au cabinet
            </td>
          </tr>

          {/* Partie 9 */}
          <tr>
            <td></td>
            <td>
              Accompagnement pour vos investissements et recherches de
              financements
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="meapvi"
                checked={formData.meapvi === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Accompagnement pour vos investissements
            </td>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
              rowSpan={2}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <select
                  name="apvi"
                  value={
                    formData.apvi.endsWith("HT € / mois")
                      ? "Honoraire"
                      : formData.apvi
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "Honoraire") {
                      setFormData({ ...formData, apvi: "" }); // prépa pour la saisie
                    } else {
                      setFormData({ ...formData, apvi: value });
                    }
                  }}
                  style={{
                    fontSize: "10px",
                    borderRadius: "4px",
                    border: "1px solid #840040",
                  }}
                >
                  <option value="N/A">N/A</option>
                  <option value="INCLUS DANS LE FORFAIT">
                    INCLUS DANS LE FORFAIT
                  </option>
                  <option value="Honoraire">Honoraire</option>
                </select>

                {/* Champ visible uniquement si on est en saisie d'honoraire */}
                {formData.apvi !== "N/A" &&
                  formData.apvi !== "INCLUS DANS LE FORFAIT" && (
                    <input
                      type="text"
                      placeholder="Ex: 33,00"
                      value={formData.apvi.replace(" HT € / mois", "")}
                      onChange={(e) => {
                        let raw = e.target.value
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        if (raw === "") {
                          setFormData({ ...formData, apvi: "" });
                          return;
                        }

                        let num = parseFloat(raw);
                        if (!isNaN(num)) {
                          // ne formate pas tout de suite, garde la saisie libre
                          const parts = raw.split(".");
                          let formatted =
                            parts.length === 2
                              ? parts[0] + "," + parts[1].substring(0, 2)
                              : parts[0];
                          setFormData({ ...formData, apvi: formatted });
                        }
                      }}
                      onBlur={() => {
                        let input = formData.apvi
                          .replace(",", ".")
                          .replace(/[^\d.]/g, "");
                        let num = parseFloat(input);
                        if (!isNaN(num)) {
                          let formatted = num.toFixed(2).replace(".", ",");
                          setFormData({
                            ...formData,
                            apvi: `${formatted} HT € / mois`,
                          });
                        } else {
                          setFormData({ ...formData, apvi: "" });
                        }
                      }}
                      style={{
                        marginTop: "5px",
                        fontSize: "10px",
                        borderRadius: "4px",
                        border: "1px solid #840040",
                      }}
                    />
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td
              style={{
                border: "1px solid black",
                textAlign: "center",
              }}
            >
              <input
                type="checkbox"
                name="merdf"
                checked={formData.merdf === "☒"}
                onChange={handleCheckboxChange}
              />
            </td>
            <td style={{ border: "1px solid black", padding: "8px" }}>
              Recherches de financements
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default LMMETableau;
